import { Center, Stack } from '@/components/ui/layout';
import { Text } from '@/components/ui/core';
import { Loader } from '@mantine/core';

export interface LoadingScreenProps {
  message?: string;
}

export function LoadingScreen({ message = 'Loading...' }: LoadingScreenProps) {
  return (
    <Center mih="100vh">
      <Stack align="center" gap="md">
        <Loader size="lg" variant="bars" />
        <Text c="dimmed">{message}</Text>
      </Stack>
    </Center>
  );
}

export default LoadingScreen;
